import { styled } from '@mui/system'
import Box from '@mui/material/Box'

const DashboardErrorBox = styled(Box)(({ theme }) => ({
	backgroundColor: theme.palette.grey[100],
	position: 'absolute',
	top: 0,
	right: 0,
	bottom: 0,
	left: 0,
	zIndex: 1,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
}))

export { DashboardErrorBox }
